import { type ChangeTeamStatusValue } from '@/api/changeTeamStatusValue.ts'

import {
  type UpdateTransportRequestOnrApiMutationOptions,
  useUpdateTransportRequestOnrApi,
} from './mutation/useUpdateTransportRequestOnrApi.ts'

export interface CompleteTransportRequestApiVariables {
  regionId: string
  transportRequestId: string
  teamStatus: ChangeTeamStatusValue
  donation: { value: number; hasReceipt: boolean }
}

export const useCompleteTransportRequest = (
  options?: UpdateTransportRequestOnrApiMutationOptions<void, CompleteTransportRequestApiVariables>
) =>
  useUpdateTransportRequestOnrApi<void, CompleteTransportRequestApiVariables>({
    type: 'piloteCompleteTransportRequest',
    ...options,
  })
